import React, { useRef } from 'react';
import { Box } from '@chakra-ui/react';
import { useLazyLoad } from '../../../../utils/lazyLoadHook';

export const LazyLoad: React.FC = (props) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const { visible: shouldLoad } = useLazyLoad(containerRef, {});
    return <Box ref={containerRef}>{shouldLoad ? props.children : null}</Box>;
};
